<div class="row">
  <div class="col-sm-10">
    <h5 class="text-center">Panel de Administracion de Usarios Admin</h5>
  </div>
  <div class="col-sm-2">
    <div class="btn-group mr-1">
      <button type="button" class="btn btn-primary  btn-sm mr-1" (click)="reset()">
        <i class="fas fa-sync-alt"></i>
      </button> 
    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-sm-12 p-2">
    <h5 class="text-center">Todos Admins de la plataforma</h5>
    <table class="table table-striped table-dark">
      <thead>
        <tr>
          <th scope="col">Nombre</th>
          <th scope="col">Email</th>
          <th scope="col">Estado</th>
          <th scope="col">Role</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <th scope="row">{{item.nombre}}</th>
          <td>{{item.email}}</td>
          <td *ngIf="item.status=='0'">Activo</td>
          <td *ngIf="item.status=='1'">Inactivo</td>
          <td *ngIf="item.role=='1'">Super Admin</td>
          <td *ngIf="item.role=='2'">Admin</td>
          <td *ngIf="item.role=='3'">Editor</td>
          <td *ngIf="item.role=='4'">Cobrador</td>
          <td>
            <div class="btn-group mr-1">
              <button type="button" class="btn btn-primary  btn-sm mr-1" (click)="edit(item)">
                <i class="fas fa-arrow-right"></i>
              </button>
              <button type="button" class="btn btn-danger  btn-sm" (click)="setchange(item)">
                <i class="fas fa-key"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-lg-6 col-md-12 col-sm-12 p-2">
    <h5 class="text-center">Crear un nuevo Admin</h5>
    <form [formGroup]="form">
      <div class="form-group">
        <label for="exampleInputEmail1">Nombre Completo</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
          formControlName="nombre">
        <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputEmail1">Email address</label>
        <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
          formControlName="email">
        <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small>
      </div>
      <div class="form-group">
        <label for="exampleInputPassword1">Password</label>
        <input type="password" class="form-control" id="exampleInputPassword1" formControlName="pass">
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Role</label>
        <select class="form-control" id="exampleFormControlSelect1" formControlName="role">
          <option value="1">Super Admin</option>
          <option value="2">Admin</option>
          <option value="3">Editor</option>
          <option value="4">Cobrador</option>
        </select>
      </div>
      <div class="form-group">
        <label for="exampleFormControlSelect1">Status</label>
        <select class="form-control" id="exampleFormControlSelect1" formControlName="status">
          <option value="0">Activo</option>
          <option value="1">Inactivo</option>        
        </select>
      </div>
      <button type="submit" *ngIf="!status && !pas" class="btn btn-primary btn-block" [disabled]="!form.valid" (click)="crear()">Crear
        Nuevo</button>
      <button type="submit" *ngIf="status && !pas" class="btn btn-warning btn-block"  (click)="save()">
        Editar</button>
      <button type="submit" *ngIf="pas" class="btn btn-info btn-block"  (click)="changepassword()">
        Cambiar Password</button>
    </form>
  </div>


</div>

<app-modal-loading [show]="modal_loading"></app-modal-loading>
